const klaviyoPopupOpen = (form_id) => {
    if (!form_id) {
        return;
    }

    window._klOnsite = window._klOnsite || [];
    window._klOnsite.push(['openForm', form_id]);
};

const initKlavbiyoPopupTrigger = () => {
    document.body.addEventListener('click', (e) => {
        const target = e.target;
        if (!target) {
            return;
        }

        const trigger = target.closest('[data-klaviyo-popup-trigger]');
        if (!trigger) {
            return;
        }

        e.preventDefault();

        const form_id = trigger.getAttribute('data-klaviyo-popup-trigger');
        if (!form_id) {
            return;
        }

        klaviyoPopupOpen(form_id);
    });
};

const initKlavbiyoPopupURLTrigger = () => {
    const url = new URL(window.location.href);
    const form_id = url.searchParams.get('popup');
    if (!form_id) {
        return;
    }
    
    klaviyoPopupOpen(form_id);
};

document.addEventListener('DOMContentLoaded', () => {
    initKlavbiyoPopupTrigger();
    initKlavbiyoPopupURLTrigger();
});